import { App, type NotificationArgsProps } from 'antd';
import { type NotificationInstance } from 'antd/es/notification/interface';

export const useNotification = (): NotificationInstance => {
  const { notification } = App.useApp();

  const success = (configConsumerProps: NotificationArgsProps): void => {
    // configConsumerProps.icon = configConsumerProps.icon ?? <CircleCheck />;
    notification.success(configConsumerProps);
  };
  const error = (configConsumerProps: NotificationArgsProps): void => {
    // configConsumerProps.icon = configConsumerProps.icon ?? <CircleX />;
    notification.error(configConsumerProps);
  };
  const warning = (configConsumerProps: NotificationArgsProps): void => {
    // configConsumerProps.icon = configConsumerProps.icon ?? <TriangleAlert />;
    notification.warning(configConsumerProps);
  };
  const info = (configConsumerProps: NotificationArgsProps): void => {
    // configConsumerProps.icon = configConsumerProps.icon ?? <CircleAlert />;
    notification.info(configConsumerProps);
  };

  return {
    ...notification,
    success,
    error,
    warning,
    info,
    open: notification.open,
  };
};
